// removed by extract-text-webpack-plugin
module.exports = {"bottomFixedContentWrapper":"G52eaa4"};